export default {
  default:
    '"Hiragino Sans","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3",Osaka,Meiryo,メイリオ,"MS PGothic","MS Pゴシック","Hiragino Sans GB","Noto Sans CJK JP","Helvetica Neue",HelveticaNeue,Helvetica,Roboto,Arial,"Arial Unicode MS",sans-serif',
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/styles/constants/Font.js